import Button from '@admin/components/button'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Details extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    profiles: PropTypes.array,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { formdata } = this.props
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Save)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)',
              name: 'title', 
              type: 'textfield',
              defaultValue: formdata.title,
              required: true 
            },
            { 
              label: 't(Description)',
              name: 'description',
              type: 'textarea',
              defaultValue: formdata.description
            },
            { 
              label: 't(Template Link)', 
              name: 'remix_url', 
              type: 'urlfield', 
              required: true,
              after: <Button { ...this._getViewUrl() } /> 
            },
            { 
              label: 't(Thumbnail)',
              name: 'thumbnail_id', 
              type: 'attachmentfield',
              defaultValue: formdata.thumbnail_id
            }
          ]
        }
      ]
    }
  }

  _getViewUrl() {
    const { formdata } = this.props
    return {
      label: 'View Design in Canva',
      className: 'link',
      link: formdata.view_url
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(resource) {
    this.props.onSave(resource)
  }

}

export default Details
